import { Injector, NgModule } from '@angular/core';
import { OpSharedModule } from "core-app/shared/shared.module";
import { OpenprojectWorkPackagesModule } from "core-app/features/work-packages/openproject-work-packages.module";
import {
  apply as applyInviteUserModalComponentPatch,
} from './patches/invite-user.component.patch';

@NgModule({
  imports: [
    OpSharedModule,
    OpenprojectWorkPackagesModule,
  ],
})
export class PluginModule {
  constructor(injector:Injector) {
    applyInviteUserModalComponentPatch();
  }
}
